<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Teams from "../../../services/Teams";

export default {
  name: "FixturesList",
  page: {
    title: "Current Fixtures",
    meta: [
      {
        name: "fixtures_currents",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BASEURL,
      /** Axios response from getFixtures; null until loaded */
      fixturesHttp: null,
      title: "Current Fixtures",
      items: [
        {
          text: "Admin",
        },
        {
          text: "Current Fixtures",
          active: true,
        },
      ],
    };
  },
  computed: {
    /**
     * Legacy: GET /team/fixtures → { success, fixtures: [] }
     * New: GET /football/matches → { matches: [] }
     */
    fixtureList() {
      if (!this.fixturesHttp || !this.fixturesHttp.data) return [];
      const d = this.fixturesHttp.data;
      const raw = d.matches || d.fixtures;
      if (!Array.isArray(raw)) return [];
      return raw.map((row) => this.normalizeFixtureRow(row));
    },
    fixtureListReversed() {
      return [...this.fixtureList].reverse();
    },
  },
  methods: {
    normalizeFixtureRow(fx) {
      const m = { ...fx };
      if (!m.competition) {
        m.competition = {
          competition_name: m.competition_name || "",
          season: m.tournament_name || m.season || "",
        };
      }
      if (!m.score || typeof m.score !== "object") m.score = {};
      if (
        (m.score.formatted == null || m.score.formatted === "") &&
        m.score_home != null &&
        m.score_away != null
      ) {
        m.score = {
          ...m.score,
          formatted: `${m.score_home} - ${m.score_away}`,
        };
      }
      if (m.home_team_short == null && m.home_team_code != null) {
        m.home_team_short = m.home_team_code;
      }
      if (m.away_team_short == null && m.away_team_code != null) {
        m.away_team_short = m.away_team_code;
      }
      if (m.past == null) {
        m.past = this.resolveFixturePastKey(m);
      }
      return m;
    },
    /**
     * Align with sport API: PAST / live (FIXTURE) / not-started (FUTURE).
     * Missing or odd match_status must not default to "live" — that incorrectly showed the next kickoff.
     */
    resolveFixturePastKey(m) {
      const st = String(m.match_status || "").toLowerCase();
      if (st === "played") return "PAST";
      if (st === "playing") return "FIXTURE";
      if (st === "awarded") return "PAST";
      if (
        st === "fixture" ||
        st === "scheduled" ||
        st === "postponed" ||
        st === "cancelled" ||
        st === "suspended"
      ) {
        return "FUTURE";
      }

      const sid =
        m.match_status_id != null && m.match_status_id !== ""
          ? Number(m.match_status_id)
          : NaN;
      if (sid === 7 || sid === 6) return "PAST";
      if (sid === 2) return "FIXTURE";
      if (sid === 1 || sid === 3 || sid === 4 || sid === 5) return "FUTURE";

      return this.inferPastFromKickoff(m);
    },
    inferPastFromKickoff(m) {
      let kickMs = null;
      if (m.unix_datetime != null && Number(m.unix_datetime) > 0) {
        kickMs = Number(m.unix_datetime) * 1000;
      } else if (m.date_time) {
        const t = new Date(String(m.date_time).replace(" ", "T")).getTime();
        if (Number.isFinite(t)) kickMs = t;
      }
      if (kickMs == null || !Number.isFinite(kickMs)) {
        return "FUTURE";
      }

      const now = Date.now();
      if (kickMs > now) {
        return "FUTURE";
      }

      const periodId =
        m.match_period_id != null ? Number(m.match_period_id) : NaN;
      if (periodId === 14) {
        return "PAST";
      }

      return "FIXTURE";
    },
    /** Row visible on list: played, live, and scheduled — not cancelled. */
    isFixtureListRowVisible(fx) {
      const st = String(fx.match_status || "").toLowerCase();
      if (st === "cancelled") return false;
      const sid =
        fx.match_status_id != null && fx.match_status_id !== ""
          ? Number(fx.match_status_id)
          : NaN;
      if (sid === 3) return false;
      return true;
    },
    getFixtures() {
      Teams.getFixtures()
        .then((response) => {
          this.fixturesHttp = response;
        })
        .catch(() => {
          this.fixturesHttp = { data: { matches: [] } };
        });
    },
  },

  mounted() {
    this.getFixtures();
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="container">
      <div class="row ">
        <div class="col-12">
          <div
            v-for="fx in fixtureListReversed"
            :key="fx.match_id"
          >
            <div
              class="card"
              v-if="isFixtureListRowVisible(fx)"
            >
              <div >
                <div class="py-3">
                  <div class="container">
                    <div class="row">
                      <div class="d-flex justify-content-between">
                        <div>
                          {{ fx.competition.competition_name }}
                          {{ fx.competition.season }}
                        </div>
                        <div>Round {{ fx.round }}</div>
                      </div>
                    </div>
                    <div
                      v-if="
                        fx.score.formatted != '' || fx.score.formatted != null
                      "
                      class="row justify-content-center"
                    >
                      {{ fx.date_formatted }}
                    </div>
                    <div class="row  align-items-center g-2">
                      <div class="col">
                        <div class="row justify-content-center">
                          <img class="w-25" :src="fx.home_team_logo" alt="" />
                        </div>
                        <div class="row fs-3 fw-bolder justify-content-center">
                          {{ fx.home_team_short }}
                        </div>
                      </div>
                      <div class="col">
                        <div
                          v-if="
                            fx.score.formatted != '' ||
                              fx.score.formatted != null
                          "
                        >
                          <div class="row fs-1  justify-content-center">
                            {{ fx.score.formatted }}
                          </div>
                        </div>
                        <div
                          class="row fs-5  justify-content-center align-items-center"
                          v-else
                        >
                          {{ fx.date_formatted }}
                        </div>
                      </div>
                      <div class="col">
                        <div class="row justify-content-center">
                          <img class="w-25" :src="fx.away_team_logo" alt="" />
                        </div>
                        <div class="row fs-3 fw-bolder justify-content-center">
                          {{ fx.away_team_short }}
                        </div>
                      </div>
                    </div>
                    <div class="row ">
                      <div class="col ">
                        <div class="d-flex justify-content-center">
                          <router-link
                            :to="{ path: `/fixtures/current/${fx.match_id}` }"
                          >
                            <button class="btn btn-primary">
                              Details
                            </button>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
